import { Http } from '../../common/api';
import { CustomerHubApiConfiguration } from '../models';

export const customerHubHttp = new Http();

export const initializeCustomerHubHttp = (config: CustomerHubApiConfiguration): void => {
  const headers = config.subscriptionKey
    ? {
        'Ocp-Apim-Subscription-Key': config.subscriptionKey,
      }
    : undefined;
  customerHubHttp.initializeHttp(config.baseUrl, headers);
};

export const isCustomerHubApiConfigured = (): boolean => {
  return customerHubHttp.isReady();
};
